"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApiUrl = void 0;
const apiConfig_1 = require("./apiConfig");
const buildApiUrl = (path, params) => {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    const base = (0, apiConfig_1.getApiBaseUrl)();
    const route = path.startsWith('/') ? path : `/${path}`;
    const searchParams = new URLSearchParams();
    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                searchParams.set(key, String(value));
            }
        });
    }
    const queryString = searchParams.toString();
    return `${base}${route}${queryString ? `?${queryString}` : ''}`;
};
exports.buildApiUrl = buildApiUrl;
